'use strict';

/* eslint no-console: 0 */
// get ALL contexts btwn start and end context
define('lib/analytics/context.get',['jquery', './config', './combineBlocks'], function ($, config, combineBlocks) {
  return function contextGet($startCtx, $endCtx) {
    var $startAt = $startCtx;
    var finalCtx = [];
    var debugFinalCtx = [];

    // if there's no END, then we cant use parentsUntil
    // pageLoads have no end
    if (!$endCtx) {
      if (config.debug && config.debug.contextGet) {
        console.groupCollapsed('DL 1.5: Context Get');
        console.log(combineBlocks($startAt.data('anctx')));
        console.log('start & end el: ', $startAt);
        console.groupEnd();
      }
      // $startAt.data('anctx') MAY be undefined. Added check for that in combineBlocks,
      // but should it exist here (and below!) as well?
      return combineBlocks($startAt.data('anctx'));
    }

    var ancestors = $startAt
      .add($startAt.parentsUntil($endCtx))
      .add($endCtx);

    $.each(ancestors, function eachAncestor(idx, node) {
      var nodeCtx = $(node).data('anctx');
      if (nodeCtx) {
        finalCtx.push(nodeCtx);
        // is this too silly, cause we have a potential spot for errors in debugging?
        if (config.debug && config.debug.contextGet) {
          debugFinalCtx.push({ el: node, ctx: nodeCtx });
        }
      }
    });

    if (config.debug && config.debug.contextGet) {
      console.groupCollapsed('DL 1.5: Context Get');
      console.log('CTX\'s found: ', debugFinalCtx);
      console.log('final CTX combined: ', combineBlocks(finalCtx));
      console.log('start el: ', $startAt);
      console.log('end el: ', $endCtx);
      console.groupEnd();
    }
    return combineBlocks(finalCtx);
  };
});

